module.exports = __webpack_public_path__ + "img/2.d3d43ef0.png";